import { Integration, IntegrationStatus, IntegrationType, getIntegrationRequest } from '@models/integration.model';

export const checkForIntegrations = (data: getIntegrationRequest) => {
  const integrations: any = {};
  const activeStatuses = [IntegrationStatus.ENABLED, IntegrationStatus.GENERATING, IntegrationStatus.GENERATED];

  if (
    data.getIntegrations.filter(
      (integration: Integration) =>
        integration.integrationType === IntegrationType.CALENDAR && activeStatuses.includes(integration.status!),
    ).length > 0
  ) {
    integrations['calendar'] = true;
  } else {
    integrations['calendar'] = false;
  }
  if (
    data.getIntegrations.filter(
      (integration: Integration) =>
        integration.integrationType === IntegrationType.STORAGE && activeStatuses.includes(integration.status!),
    ).length > 0
  ) {
    integrations['storage'] = true;
  } else {
    integrations['storage'] = false;
  }

  return integrations;
};
